// extracted by mini-css-extract-plugin
module.exports = {"snake-pager":"snake-pager_snake-pager__katXV","snake-pager__item":"snake-pager_snake-pager__item__DuPuR","active":"snake-pager_active__2h6eN"};